import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import pageNav from './components/pageNav.vue';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue)
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import { scrollByRef, getStore, setStore,getNavListByType,countViewCount } from "@/utils/utils"
import "./assets/css/quill.core.css"
Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component('pageNav', pageNav)
Vue.prototype.$BaseUrl = process.env.VUE_APP_BASE_API
Vue.prototype.scrollByRef = scrollByRef
Vue.prototype.getStore = getStore
Vue.prototype.setStore = setStore
Vue.prototype.getNavListByType=getNavListByType
Vue.prototype.countViewCount=countViewCount
// Vue.prototype.$BaseUrl='http://114.67.202.45:29092'
Vue.use(Element)
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

